import { IMedia } from '../../mediaPreview.types.ts'
import css from './header.module.css'
import filesUtils from '../../../Files/files.utils.ts'
import CloseButton from '../../../Buttons/CloseButton'
import DownloadButton from '../../../Buttons/DownloadButton'

interface IProps {
  media: IMedia
  onClose: () => void
}

const Header = (props: IProps) => {
  return (
    <div className={css.wrapper}>
      <div className="inline-flex-gap gap24 center">
        <p className="text-nm text-white">{props.media.fileName || 'Без имени'}</p>
        <p className="text-nm text-white">{filesUtils.humanFileSize(props.media.size)}</p>
      </div>
      <div className="inline-flex-gap gap16 center">
        <DownloadButton
          downloadFilename={props.media.fileName}
          downloadUrl={props.media.url}
          iconStyle={{ color: '#fff' }}
        />
        <CloseButton onClick={props.onClose} iconStyle={{ color: '#fff' }} />
      </div>
    </div>
  )
}

export default Header
